import Vue from 'vue'
import Router from 'vue-router'
import Index from '../../components/help_center/Index.vue'
import ArticleDetail from '../../components/help_center/ArticleDetail.vue'
import TopicsCard from '../../components/help_center/TopicsCard.vue'
import DocumentLibrary from '../../document_library.vue'
import ReportTemplatesDetail from '../../components/report_templates/ReportTemplatesDetail.vue'
import ReportListDetail from '../../components/report_list/report_view/ReportView.vue'
import ScheduledReport from '../../components/schedule_report/ScheduledReport.vue'
import NewScheduledReport from '../../components/schedule_report/NewScheduledReport.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes:[
    {
      path: '/dashboard/help_center',
      name: 'Index',
      component: Index
    },
    {
      path: '/dashboard/help_center/articles/:id',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/dashboard/help_center/topics',
      name: 'TopicsCard',
      component: TopicsCard
    },
    {
      path: '/dashboard/help_center/topics/:id',
      name: 'TopicArticles',
      component: ArticleDetail
    },
    {
      path: '/dashboard/documents',
      name: 'Documents',
      component: DocumentLibrary
    },
    {
      path: '/dashboard/template_builder/:id',
      name: 'ReportTemplatesDetail',
      component: ReportTemplatesDetail
    },
    {
      path: '/dashboard/report_list/:id',
      name: 'ReportListDetail',
      component: ReportListDetail
    },
    {
      path: '/dashboard/scheduled_report',
      name: 'ScheduledReport',
      component: ScheduledReport
    },
    {
      path: '/dashboard/scheduled_report/new',
      name: 'ScheduledReportNew',
      component: NewScheduledReport
    }
  ]
})
